import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { appStatus } from "../../store/modules/app_status/actions";
import { canEditUserRecord } from "../../utils/userRoles";
import {
  Wrapper,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Container,
  CardActions,
  CardActionButton,
} from "./styles";

const UsersCard = ({ filteredUsers }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user.currentUser);
  const rows = Array.isArray(filteredUsers) ? filteredUsers : [];

  const handleGoToEditUser = (user) => {
    if (!canEditUserRecord(currentUser, user)) return;
    dispatch(appStatus("edit_user"));
    navigate("/welcome", { state: { user } });
  };

  return (
    <Container>
      <Wrapper>
        {rows.map((user, index) => {
          const canEdit = canEditUserRecord(currentUser, user);
          return (
            <Card key={user.id || index}>
              <CardHeader>{user.owner || user.full_name}</CardHeader>
              <CardBody>
                <p>{user.full_name}</p>
                <p>{user.email}</p>
                <p>{user.phone}</p>
                <p>
                  {user.city}, {user.state}
                </p>
              </CardBody>
              <CardFooter>{user.user_type || "Usuário"}</CardFooter>
              {canEdit ? (
                <CardActions>
                  <CardActionButton
                    type="button"
                    onClick={() => handleGoToEditUser(user)}
                  >
                    Editar
                  </CardActionButton>
                </CardActions>
              ) : null}
            </Card>
          );
        })}
      </Wrapper>
    </Container>
  );
};

export default UsersCard;
